import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import { motion } from 'framer-motion';
import { createIndexArray } from 'hx-util';
export function AnimatedCircles(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 8 : _b, _c = _a.size, size = _c === void 0 ? 7 : _c, children = _a.children, color = _a.color, _d = _a.count, count = _d === void 0 ? 3 : _d, min = _a.min, max = _a.max, _e = _a.delayOffset, delayOffset = _e === void 0 ? true : _e, _f = _a.delayOffsetTransform, delayOffsetTransform = _f === void 0 ? function (index) { return index / 4; } : _f, _g = _a.minTransform, minTransform = _g === void 0 ? function (index) { return 0.9 + index * 0.2; } : _g, _h = _a.maxTransform, maxTransform = _h === void 0 ? function (index) { return 1.5 + index * 0.5; } : _h, _j = _a.opacity, opacity = _j === void 0 ? 0.1 : _j, opacityTransform = _a.opacityTransform, colorTransform = _a.colorTransform;
    var offsets = createIndexArray(count);
    return (_jsxs(Wrapper, { children: [offsets.map(function (index) { return (_jsx(Circles, { color: color, size: size, zIndex: -2 - index, opacity: (opacityTransform === null || opacityTransform === void 0 ? void 0 : opacityTransform(index, count)) || opacity, backgroundColor: colorTransform === null || colorTransform === void 0 ? void 0 : colorTransform(index, count), animate: {
                    scale: [
                        min || minTransform(index),
                        max || maxTransform(index),
                        min || minTransform(index),
                    ],
                }, transition: {
                    repeat: Infinity,
                    type: 'spring',
                    duration: duration,
                    delay: delayOffset && delayOffsetTransform(index),
                } }, "animated-circles-".concat(index))); }), _jsx(InnerCircle, { color: color, size: size }), children] }));
}
var Circles = styled(motion.div, {
    shouldForwardProp: function (prop) {
        return prop !== 'color' && prop !== 'size' && prop !== 'opacity';
    },
})(function (_a) {
    var theme = _a.theme, color = _a.color, size = _a.size, opacity = _a.opacity, backgroundColor = _a.backgroundColor, zIndex = _a.zIndex;
    return ({
        minHeight: "".concat(size, "rem"),
        minWidth: "".concat(size, "rem"),
        borderRadius: '99999px',
        backgroundColor: backgroundColor || color || theme.palette.primary.main,
        position: 'absolute',
        zIndex: zIndex,
        opacity: opacity,
    });
});
var InnerCircle = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'color' && prop !== 'size'; },
})(function (_a) {
    var theme = _a.theme, color = _a.color, size = _a.size;
    return ({
        minHeight: "".concat(size, "rem"),
        minWidth: "".concat(size, "rem"),
        borderRadius: '99999px',
        backgroundColor: color || theme.palette.primary.main,
        position: 'absolute',
        zIndex: -1,
    });
});
var Wrapper = styled('div')({
    display: 'grid',
    placeItems: 'center',
    position: 'relative',
});
